export enum NotificationType {
  expenseSubmitted = "expenseSubmitted",
  expenseApproved = "expenseApproved",
  expenseRejected = "expenseRejected",
  expenseReimbursed = "expenseReimbursed",
  policyUpdated = "policyUpdated",
  mileageRateUpdated = "mileageRateUpdated",
  subscriptionPurchased = "subscriptionPurchased",
}
